export const X_BOTTOM_OFFSET = 0.5;
export const TICK_ROTATE_DEG = 45;
export const TICK_LABEL_FONT_SIZE = 10;
